import { render } from "./ButtonHeader.vue?vue&type=template&id=41b5bc8c&scoped=true&ts=true"
import script from "./ButtonHeader.ts?vue&type=script&lang=ts&external"
export * from "./ButtonHeader.ts?vue&type=script&lang=ts&external"

import "./ButtonHeader.scss?vue&type=style&index=0&id=41b5bc8c&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b5bc8c"]])

export default __exports__